import azentFadedSvg from "@/assets/azentFadedSvg.svg";
import QRCode from "@/assets/qrCode.svg";

const NOTES_CHECKBOX_OPTIONS = {
    HIGH_POTENTIAL: "High potential",
    NEED_IELTS: "Need IELTS coaching",
    HAS_IELTS: "Already has an IELTS score",
    ALREADY_APPLIED: "Has applied already",
    HAS_OFFER: "Has an offer",
    APPLIED_AT_DESK: "Applied at desk",
    PROSPECTIVE_APPLICANT: "Prospective Applicant",
    INTERESTED_IN_LOANS: "Interested in Loans",
    FUTURE_INTAKE: "Future Intake"
};

NOTES_CHECKBOX_OPTIONS.ENUMS = Object.values(NOTES_CHECKBOX_OPTIONS);

const DEFALUT_PENDING_DOCUMENT_LIST = ["Grade 10 mark sheet", "Grade 12 mark sheet", "Passport"];
const PENDING_DOCUMENT_OPTIONS = {
    [DEFALUT_PENDING_DOCUMENT_LIST[0]]: true,
    "Grade 10 passing certificate": true,
    "Grade 10 admit card": true,
    [DEFALUT_PENDING_DOCUMENT_LIST[1]]: true,
    "Grade 12 passing certificate": true,
    "Grade 12 admit card": true,
    "Graduation mark sheet": true,
    "Graduation degree certificate": true,
    "Graduation degree transcript": true,
    "Graduation degree provisional certificate": true,
    "Graduation degree backlog certificate": true,
    "Masters mark sheet": true,
    "Masters degree certificate": true,
    "Masters degree transcript": true,
    "Masters degree provisional certificate": true,
    "Masters degree backlog certificate": true,
    "Phd documents": true,
    IELTS: true,
    TOEFL: true,
    DUOLINGO: true,
    GRE: true,
    GMAT: true,
    PTE: true,
    SAT: true,
    "Experience Letter": true,
    OfferLetter: true,
    Resume: true,
    [DEFALUT_PENDING_DOCUMENT_LIST[2]]: true,
    Photograph: true,
    SOP: true,
    LOR: true,
    "Visa approval letter": true,
    "Deposit slips": true,
    "Offer letter": true,
    Other: true,
};
PENDING_DOCUMENT_OPTIONS.ENUMS = Object.keys(PENDING_DOCUMENT_OPTIONS);

const getDashboardProps = (universityName, eventDate) => {
    return {
        noStudentBoxProps: {
            defaultText: "Please enter students Unique Id to view more details.",
        },
        studentSearchProps: {
            azentFadedSvg,
            QRCode,
            headingSection: {
                title: `Welcome ${universityName}`,
                subTitle: `to Azent Overseas Education Fair - ${eventDate}`,
            },
            inputBox: {
                label: "Enter Uniquie Id",
                placeholder: "Enter up to 5 unique ids",
                closeIconLabel: "Clear All",
            },
            searchButton: {
                label: "Find",
                variant: "contained",
                color: "success",
            },
        },
    };
};

export default getDashboardProps;
export { NOTES_CHECKBOX_OPTIONS, PENDING_DOCUMENT_OPTIONS, DEFALUT_PENDING_DOCUMENT_LIST };
